import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {assignProductUserEntitlementsStateSelector} from './assign-product-user-entitlements-state.slice';

import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {ResourceView} from 'src/modules/entitlements/typedef';

export const assignProductUserEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    {resourceIds?: string[], resourceQuery: string}
>('assignProductUserEntitlements');

export const assignProductUserEntitlementsActions = assignProductUserEntitlementsSlice.actions;
export const assignProductUserEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.userPage.assignProductEntitlements.result.cache;
export const assignProductUserEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.userPage.assignProductEntitlements.result;

export const assignProductUserEntitlementsResultSelector = getCachedTableResultSelector(
    assignProductUserEntitlementsCacheSelector,
    assignProductUserEntitlementsStateSelector,
);
